
import { BASE_URL } from '../constants';
import { errorHandling, errorHandler } from '../utils/errorHandling';
// import { getItem } from '../utils/localStore';

class getProfileApi {
    static doGetprofile(token) {
        let isError = false;
        try{
            const ajaxRequestHeaders = new Headers({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Authorization': token
            });
            let body = {
                method: 'GET',
                headers: ajaxRequestHeaders
            }
            return fetch(BASE_URL + '/users', body).then(response => {
                isError = errorHandling(response);
                return response.json();
            }).catch(error => {
                if (error && !isError) {
                    errorHandler(error);
                }
                return error;
            });
        }catch(err){
            return err
        }
    }
}

export default getProfileApi;